export const css = {
    welcome: '_2AHsDS-b',
    skip: 'll_3IWNW',
    ' _key': 'afcpe-theme/afcpe/landing-page/welcome-view'
};
export default css;
